import logo from "../../oversight-core/assets/images/atutu-logo.png";

const Logo = () => {
  return <img src={logo} alt="oversight_logo" width={130} height={50} />;
};

export default Logo;
